
export const SectionId = {
  HOME: 'home',
  ROOMS: 'rooms',
  GALLERY: 'gallery',
  TESTIMONIALS: 'testimonials',
  ABOUT: 'about',
  CONTACT: 'contact',
};
